/**
 * @generated SignedSource<<1bc7d0cd10758aed0c33c1d3c8b1b267>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentItemRenderContent$data = {
  readonly __typename: "Video";
  readonly " $fragmentSpreads": FragmentRefs<"cardContentItemContent" | "contentActionBarContent" | "contentAuthorLinkContent" | "contentCoverImageContent" | "contentHeadlineContent" | "contentLiveTagContent" | "contentPrintHeadlineContent" | "contentSubHeadlineContent" | "contentSummaryContent" | "contentTopicLinkContent" | "entityLink" | "hooksUseContentSponsorContent" | "morningStudioContentItemContent" | "opinionContentItemContent" | "primaryContentItemContent" | "searchContentItemContent" | "secondaryContentItemContent" | "videoDurationOverlayVideo">;
  readonly " $fragmentType": "contentItemRenderContent";
};
export type contentItemRenderContent$key = {
  readonly " $data"?: contentItemRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentItemRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentActionBarContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSummaryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentPrintHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentTopicLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentAuthorLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "primaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "secondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "searchContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "opinionContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "cardContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseContentSponsorContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "videoDurationOverlayVideo"
        }
      ],
      "type": "Video",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "3c88e4a7388e90cc9c1597fe5cac8e8c";

export default node;
